import React from "react";
import DashboardPane from "../pane/dashboard_pane";
import ProjectListPane from "./project/project_list";
import MonitoringEvaluationListPane from "./project/monitoring_evaluation_list";
import ReportListPane from "./report/report_list";
import PaymentListPane from "./payment/payment_list";
import DashboardStakeholderPane from "../pane/dashboard_stakeholder_pane";
import FilesListPane from "../pane/files_list";
import LandUsePlansPane from "./project/land_use_plans";
import LandUsesPane from "./project/land_uses";


export default class ScreenCodeToComponent {

    static getScreenByCode(code) {

        switch (code) {
            case 'dashboard':
                if (sessionStorage.getItem('user_group') === 'STAKEHOLDER') {
                    return <DashboardStakeholderPane key={new Date().getMilliseconds()}/>
                } else {
                    return <DashboardPane key={new Date().getMilliseconds()}/>
                }
            case 'land_use_plans':
                return <LandUsePlansPane key={new Date().getMilliseconds()}/>
            case 'land_uses':
                return <LandUsesPane key={new Date().getMilliseconds()}/>
            case 'projects':
                return <ProjectListPane key={new Date().getMilliseconds()}/>
            case 'monitoring':
                return <MonitoringEvaluationListPane key={new Date().getMilliseconds()}/>
            case 'payment':
                return <PaymentListPane key={new Date().getMilliseconds()}/>
            case 'reports':
                return <ReportListPane key={new Date().getMilliseconds()}/>
            case 'files':
                return <FilesListPane key={new Date().getMilliseconds()}/>
        }
        return code;
    }

}